import { httpRequest } from "../../http";
import { ScheduleSegmentSerializer } from "@models/serializers/scheduleSegmentSerializer";
import { ScheduleSegment } from "@models/ScheduleSegment.model";

export class CommandCreateScheduleSegment {
    async run(segment: ScheduleSegment) {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/schedules/segments/`
       
        try {
            const response = await httpRequest<any>(url, { method: "POST", body: new ScheduleSegmentSerializer().serialize(segment) });
            return this.deserialize(response);
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    deserialize(data: any) {
        return new ScheduleSegmentSerializer().deserialize(data)
    }

  
}



